<template>
  <Html lang="en">
    <Body :data-theme="theme" class="stage">
      <TransitionFade>
        <Preloader v-if="route.name === `index` && !ready" :is-loading="isLoading" />
      </TransitionFade>
      <NuxtLoadingIndicator :color="'#b991f0'" :height="4" />
      <div id="navbar-trigger" class="h-[20px] absolute pointer-events-none touch-none top-0 w-full"/>
      <ClientOnly>
        <UINavbarNew v-if="route.name === `index` && ready" @open-contact-form="openContactForm=true" />
        <UINavbarNew v-else-if="route.name !== `index`" @open-contact-form="openContactForm=true" />
      </ClientOnly>
      <div>
        <NuxtPageWrapper @on-loaded="isLoading = false; ready = true" @open-contact-form="openContactForm=true"/>
      </div>
      <div
id="circle-cursor"
        :class="[
          {'ring-[2px] ring-white shadow-sm': hoveringButton.isHover && hoveringButton.type == 'default'},
        ]" class="transition-scale transition-ring w-[2rem] h-[2rem] rounded-full overflow-visible -translate-y-3 -translate-x-3 hidden lg:block">
          <div
id="circle-cursor-inner"
          :class="[
            {'scale-0 opacity-0': hoveringButton.isHover && hoveringButton.type == 'drag'},
            {'scale-[0.35] bg-white shadow-black shadow-md': hoveringButton.isHover && hoveringButton.type == 'default'},
            {'scale-[1.4] bg-ellie-blue': hoveringButton.isHover && hoveringButton.type == 'arrow'}
          ]" class="flex items-center justify-center origin-center -translate-x-[1px] -translate-y-[1px] transition-all duration-500 w-[2rem] h-[2rem] rounded-full bg-black/30 backdrop-blur-sm overflow-hidden">
          <svg
:class="[
            {'scale-100 opacity-100': hoveringButton.isHover && hoveringButton.type == 'arrow'},
            {'scale-0': !hoveringButton.isHover && hoveringButton.type != 'arrow'},
            ]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-white transition-scale duration-500 delay-75 opacity-0">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
          </div>
          <div
            class="drag-cursor absolute hidden lg:block"
            :class="[
              {'invisible': hoveringButton.type != 'drag'},
            ]"
            >
            <div
              :class="[
                {'invisible scale-75 opacity-0 bg-white': !hoveringButton.isHover && hoveringButton.type != 'drag'},
                {'visible scale-100 opacity-100 bg-white': hoveringButton.isHover && hoveringButton.type == 'drag' && !touch.start},
                {'scale-90 bg-gray-800 text-white': hoveringButton.isHover && touch.start},
              ]"
              class="transition-all duration-300 px-3 py-3 shadow-xl rounded-full flex items-center gap-1 -translate-x-11 -translate-y-9">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
              </svg>
                DRAG
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 rotate-180">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
              </svg>
              </div>
          </div>
      </div>

      <div id="floating-thumbnail-wrapper" :class="[{'invisible opacity-0': !floatingThumbnail.url}]" class="pointer-events-none fixed z-20 left-0 top-0 w-[380px] overflow-visible -translate-x-1/2 -translate-y-1/2">
          <div id="thumbnail-inner" class="transition-transform duration-200 delay-300 shadow-xl rounded-2xl overflow-hidden">
            <transition name="fade">
              <img v-if="floatingThumbnail.url" id="floating-thumbnail" :src="floatingThumbnail.url" class="w-full h-full object-cover aspect-[4/3]" >
            </transition>
          </div>
      </div>

      <div id="circular-animated-cursor" class="hidden md:block pointer-events-none fixed z-20 left-0 top-0 w-24 h-24 rounded-full overflow-visible -translate-x-[calc(50%-3px)] -translate-y-[calc(50%-3px)]">
          <div class=" rounded-full overflow-visible">
            <transition name="fade">
              <div v-if="hoveringButton.isHover && hoveringButton.type == 'scroll-down'" class="relative rotating w-24 h-24">
                  <svg class="" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path
    id="circlePath" fill="none" stroke-width="4" stroke="hsl(0 100% 50% / 0)" d="
                          M 10, 50
                          a 40,40 0 1,1 80,0
                          a 40,40 0 1,1 -80,0
                        " />
                    <text class="circular-text" font-size="14.1" font-weight="normal" fill="var(--text-1)">
                      <textPath class="textPath flex items-center" href="#circlePath">• SCROLL DOWN</textPath>
                    </text>
                  </svg>
                  <svg class="rotate-[180deg] -translate-y-24" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path
    id="circlePath" fill="none" stroke-width="4" stroke="hsl(0 100% 50% / 0)" d="
                          M 10, 50
                          a 40,40 0 1,1 80,0
                          a 40,40 0 1,1 -80,0
                        " />
                    <text class="circular-text" font-size="14.1" font-weight="normal" fill="var(--text-1)">
                      <textPath class="textPath flex items-center" href="#circlePath">• SCROLL DOWN</textPath>
                    </text>
                  </svg>
              </div>
            </transition>
          </div>
      </div>

      <Transition name="slide-up-2" mode="out-in">
        <ContactPopup v-if="openContactForm" @close="openContactForm=false" />
      </Transition>
    </Body>
  </Html>
</template>

<script setup>
await preloadComponents('preloader');
const { $VanillaTilt } = useNuxtApp();
const route = useRoute();
const mainStore = useMainStore();
const navbarStore = useNavbarStore();
const openContactForm = ref(false)
useHead({
  script: [
    {
      key: 'prevent-script',
      children: `
          window.addEventListener("nuxt-booster:run", function (e) {
            if (!e.detail.sufficient) {
              // added style class to display the content
              document.querySelector('.stage')?.classList.add('visible')
            }
          });
        `,
    },
  ],
});
const theme = ref(null);
const isLoading = ref(true);
const ready = ref(false);
const hoveringButton = computed(() => mainStore.track);
const touch = computed(() => mainStore.touch);
const floatingThumbnail = computed(() => mainStore.floatingThumbnail);
const isL = useMediaQuery('(min-width: 1024px)');
watch(() => isLoading.value,
  (val) => {
    if (!val) {
      navbarStore.displayDocument();
    }
  },
);
watch(theme, (value) => {
  localStorage.setItem('daisyui-theme', value);
});

watch(() => floatingThumbnail.value, (val) => {
  if (val && val.url) {
    // init3DHover();
  }
});

onMounted(() => {
  const payload = {
    isHover: false,
    type: 'default',
  }
  mainStore.toggleTrackingMouse(payload)
  const customCursor = document.getElementById('circle-cursor');
  const wrapperEl = document.getElementById('floating-thumbnail-wrapper');
  const innerEl = document.getElementById('thumbnail-inner');
  const circularTextEl = document.getElementById('circular-animated-cursor');

  let cursorX = 0, cursorY = 0;
  let delayedX = 0, delayedY = 0, delayedX2 = 0, delayedY2 = 0;
  const delay = 20; // Delay factor (smaller = less delay)

  function updatePosition () {
    // Smoothly update positions with interpolation
    delayedX += (cursorX - delayedX) / delay;
    delayedY += (cursorY - delayedY) / delay;

    delayedX2 += (cursorX - delayedX2) / (delay / 3);
    delayedY2 += (cursorY - delayedY2) / (delay / 3);

    // Update floating thumbnail position
    wrapperEl.style.left = `${delayedX}px`;
    wrapperEl.style.top = `${delayedY}px`;
    circularTextEl.style.left = `${delayedX2}px`;
    circularTextEl.style.top = `${delayedY2}px`;

    const { innerWidth, innerHeight } = window;
    const offsetX = ((cursorX / innerWidth) - 0.5) * 30; // Horizontal rotation
    const offsetY = ((cursorY / innerHeight) - 0.5) * 30; // Vertical rotation
    const translateX = ((cursorX / innerWidth) - 0.5) * 30; // Horizontal translation
    const translateY = ((cursorY / innerHeight) - 0.5) * 30; // Vertical translation
    const depth = Math.abs((cursorX / innerWidth) - 0.5) * 50; // Z-depth adjustment

    // Update transform for 3D hover effect
    innerEl.style.transform = `
      perspective(1000px)
      translate3d(${translateX}px, ${translateY}px, ${depth}px)
      rotateX(${-offsetY}deg)
      rotateY(${offsetX}deg)
    `;
    innerEl.style.transform += ' scale(1.1)';

    // Continue the animation loop
    requestAnimationFrame(updatePosition);
  }

  document.addEventListener('mousemove', (e) => {
    cursorX = e.clientX;
    cursorY = e.clientY;
    // Update custom cursor position
    customCursor.style.left = `${cursorX}px`;
    customCursor.style.top = `${cursorY}px`;
  });

  // Start the animation loop
  requestAnimationFrame(updatePosition);
});

const init3DHover = () => {
  const Hover3DCard = document.querySelectorAll('.floating-thumbnail');
  $VanillaTilt.init(Hover3DCard, {
    max: 10,
    speed: 2000,
  });
};

watch (() => openContactForm.value, (val) => {
  if (val) {
    document.querySelector('body').style.overflow = 'hidden';
  } else {
    document.querySelector('body').style.overflow = 'auto';
  }
})
</script>

<style lang="scss" scoped>
  #circle-cursor {
    position: fixed;
    pointer-events: none; /* Prevents interaction issues */
    z-index: 9999999; /* Ensures it's above all other elements */
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  #floating-thumbnail-wrapper {
    perspective: 1000px;
    will-change: transform;
  }

  #thumbnail-inner {
    transition: opacity 0.3s ease, transform 0.3s ease;
    transform-style: preserve-3d;
    will-change: transform;
  }

  #floating-thumbnail {
    transform-origin: center;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease, transform .3s ease;
  }

  .fade-enter-from, .fade-leave-to {
    opacity: 0;
    transform: scale(0);
  }

  .fade-enter-to, .fade-leave-from {
    opacity: 1;
    transform: scale(1);
  }

  @-webkit-keyframes rotating {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  .rotating {
    -webkit-animation: rotating 8s linear infinite;
    -moz-animation: rotating 8s linear infinite;
    -ms-animation: rotating 8s linear infinite;
    -o-animation: rotating 8s linear infinite;
    animation: rotating 8s linear infinite;
  }
</style>
